export function isNegative(value: number) {
    const sign = Math.sign(value).toString()
    return sign === '-1' || sign === '-0'
}